// extracted by mini-css-extract-plugin
module.exports = {"mapViewSwitch":"map-view-switch_mapViewSwitch__UjLTw","mapViewSwitch_mapIcon":"map-view-switch_mapViewSwitch_mapIcon__NCgkK"};